export var ErrorCodeCategory;
(function (ErrorCodeCategory) {
    ErrorCodeCategory["accessDenied"] = "kAccessDenied";
    ErrorCodeCategory["notLoggedIn"] = "kNotLoggedIn";
    ErrorCodeCategory["validationError"] = "kValidationError";
})(ErrorCodeCategory || (ErrorCodeCategory = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ACCESS_DENIED_ACCOUNT_LOCKED"] = "iam.accessDenied.accountLocked";
    ErrorCode["ACCESS_DENIED_INVALID_CREDENTIALS"] = "iam.accessDenied.invalidCredentials";
    ErrorCode["ACCESS_DENIED_PASSWORD_EXPIRED"] = "iam.accessDenied.passwordExpired";
    ErrorCode["ACCESS_DENIED_INVALID_TOKEN"] = "mom.accessDenied.invalidToken";
    ErrorCode["ACCESS_DENIED_REDEPLOYMENT"] = "mom.accessDenied.redployment";
    ErrorCode["ACCESS_DENIED_TARGET_ORG"] = "mom.accessDenied.targetOrg";
    ErrorCode["ACCESS_DENIED_UPDATE_ENVIRONMENT_ACCESS"] = "mom.accessDenied.updateEnvironmentAccess";
    ErrorCode["ACCESS_DENIED_STUDY_DEPLOYMENT_ACCESS"] = "mom.accessDenied.studyDeploymentAccess";
    ErrorCode["ACCESS_DENIED_POLICY"] = "mom.accessDenied.policy";
    ErrorCode["ACCESS_DENIED_LEGACY_STUDY"] = "mom.accessDenied.legacyStudy";
    ErrorCode["ACCESS_DENIED_NON_APPROVED_STUDY_DEPLOYMENT"] = "mom.accessDenied.nonApprovedStudyDeployment";
    ErrorCode["CONFLICT_ENVIRONMENT_NOT_PROVISIONED"] = "mom.conflict.environmentNotProvisioned";
    ErrorCode["CONFLICT_ENVIRONMENT_PROVISION"] = "mom.conflict.environmentProvision";
    ErrorCode["CONFLICT_HIDE_NON_EPHEMERAL"] = "mom.conflict.hideNonEphemeral";
    ErrorCode["CONFLICT_HIDE_INVALID_STATUS"] = "mom.conflict.hideInvalidStatus";
    ErrorCode["CONFLICT_INSTANCE_DELETE"] = "mom.conflict.instanceDelete";
    ErrorCode["ENTITY_ACCESS_EXISTS"] = "mom.conflict.entityAccessExists";
    ErrorCode["SITE_NUMBER_EXISTS"] = "mom.conflict.siteNumberExists";
    ErrorCode["EXISTING_SITE_IN_ENVIRONMENT"] = "mom.conflict.workspaceSiteExistsInEnvironment";
    ErrorCode["ERROR_ENVIRONMENT_SITE_UPDATE"] = "mom.error.environmentSiteUpdate";
    ErrorCode["ERROR_STUDY_CREATE"] = "mom.error.studyCreate";
    ErrorCode["IDENTITY_NOT_VERIFIED"] = "iam.accessDenied.unverified";
    ErrorCode["PASSWORD_STRENGTH"] = "iam.invalidArgument.passwordStrength";
    ErrorCode["PROD_ENVIRONMENT_LIMIT_REACHED"] = "mom.accessDenied.maxEnvironments";
    ErrorCode["USED_PASSWORD"] = "iam.invalidArgument.usedPassword";
    ErrorCode["ACCESS_DENIED_SSO_REQUIRED"] = "iam.accessDenied.ssoRequired";
    ErrorCode["INVALID_ARGUMENT_INVALID_TOKEN"] = "iam.invalidArgument.invalidToken";
    // mom.invalidArgument.* family
    ErrorCode["INVALID_ARGUMENT_SORT"] = "mom.invalidArgument.sort";
    ErrorCode["INVALID_ARGUMENT_CLUSTER_TYPE"] = "mom.invalidArgument.clusterType";
    ErrorCode["INVALID_ARGUMENT_ROLE_GROUP"] = "mom.invalidArgument.roleGroup";
    ErrorCode["INVALID_ARGUMENT_ENVIRONMENT_NOT_PROVISIONED"] = "mom.invalidArgument.environmentNotProvisioned";
    ErrorCode["INVALID_ARGUMENT_PROD_SITE_CAN_ONLY_BE_ADDED_TO_PROD_ENVS"] = "mom.invalidArgument.prodSiteCanOnlyBeAddedToProdEnvs";
    ErrorCode["INVALID_ARGUMENT_ADMIN_PASSWORD_SCORE"] = "mom.invalidArgument.adminPasswordScore";
    ErrorCode["INVALID_ARGUMENT_BAYMAX_TEMPLATE"] = "mom.invalidArgument.baymaxTemplate";
    ErrorCode["INVALID_ARGUMENT_SITE_TYPE_UPDATE"] = "mom.invalidArgument.siteTypeUpdate";
    // mom.notFound.* family (SSP-4201)
    ErrorCode["NOT_FOUND_ENTITY"] = "mom.notFound.entity";
    ErrorCode["NOT_FOUND_STUDY"] = "mom.notFound.study";
    ErrorCode["NOT_FOUND_ENVIRONMENT"] = "mom.notFound.environment";
    ErrorCode["NOT_FOUND_ENVIRONMENT_SITE"] = "mom.notFound.environmentSite";
    ErrorCode["NOT_FOUND_SITE"] = "mom.notFound.site";
    ErrorCode["NOT_FOUND_IDENTITY"] = "mom.notFound.identity";
    ErrorCode["NOT_FOUND_ENTITY_ACCESS"] = "mom.notFound.entityAccess";
    ErrorCode["NOT_FOUND_STUDY_CONFIG"] = "mom.notFound.studyConfig";
    ErrorCode["NOT_FOUND_WORKFLOW"] = "mom.notFound.workflow";
    ErrorCode["NOT_FOUND_IDP"] = "mom.notFound.idp";
})(ErrorCode || (ErrorCode = {}));
